import { Pipe, PipeTransform } from '@angular/core';
import {
  DenormalizedJobType,
  DenormalizedJobTypeJson,
  JobTypeServiceCreateResponse,
  JobTypeServiceCreateResponseJson,
} from '@vmspdb/definitions';

@Pipe({
  name: 'jobTypeDisplay',
  standalone: true,
})
export class JobTypeDisplayPipe implements PipeTransform {
  transform(
    value?:
      | JobTypeServiceCreateResponse
      | DenormalizedJobType
      | JobTypeServiceCreateResponseJson
      | DenormalizedJobTypeJson,
  ): string {
    return formatJobType(value);
  }
}

export function formatJobType(
  value?:
    | JobTypeServiceCreateResponse
    | DenormalizedJobType
    | JobTypeServiceCreateResponseJson
    | DenormalizedJobTypeJson,
): string {
  if (!value) {
    return 'Unknown';
  }

  return value.description
    ? `${value.name} (${value.description})`
    : (value.name ?? 'Unknown');
}
